import { useEffect, useState } from 'react';
import { Content, Table } from 'components';
import { stringToMoneyFormat } from 'utils';
import { Link } from 'react-router-dom';
import { handleSearchKeyword } from 'utils/SearchKeyword';
const ProductTable = ({ selectedSearchWord, productList }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (selectedSearchWord) {
      const findProducts = handleSearchKeyword(
        productList,
        selectedSearchWord?.search_word ?? null,
        'product_name'
      );
      setProducts(findProducts);
    }
  }, [selectedSearchWord]);

  return (
    <Content
      maxWidth={'100%'}
      borderRadius={4}
      padding={20}
      style={{ height: '100%' }}
    >
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
        추천검색어 별 상품 총 <span>{products?.length}</span>건
      </h4>
      <Table
        data={products}
        columns={[
          {
            title: '상품번호',
            key: 'product_id',
          },
          {
            title: '상품코드',
            key: 'product_code',
          },
          {
            title: '상품명',
            key: 'product_name',
            render: (item, product) => {
              return (
                <Link to={`/product/list/${product?.product_id}`}>{item}</Link>
              );
            },
          },
          {
            title: '재고수량',
            key: 'num',
            render: (item) => `${item} EA`,
          },
          {
            title: '판매가',
            key: 'price',
            render: (item) => `${stringToMoneyFormat(item)} 원`,
          },
          {
            title: '등록일',
            key: 'created_at',
          },
        ]}
      />
    </Content>
  );
};

export default ProductTable;
